"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = root;
var _effects = require("redux-saga/effects");
var _sagas = require("../../utils/sagas");
var types = _interopRequireWildcard(require("./types"));
var _apis = require("./apis");
var _selectors = require("./selectors");
var _actions = require("./actions");
var _actions2 = require("../notification/actions");
var _constants = require("./constants");
var _schemas = require("./schemas");
var _middlewares = require("../network/middlewares");
var _api = require("../../utils/api");
var _types2 = require("../session/types");
var _types3 = require("../websocket/types");
var _errorHandler = _interopRequireDefault(require("../../utils/errorHandler"));
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function* getNbContacts() {
  try {
    var {
      headers
    } = yield (0, _effects.call)(_apis.$getNbContacts);

    // headers.content-range looks like this "0 - 50 / 619"
    var nbContacts = Number(headers['content-range'].split('/')[1]);
    yield (0, _effects.put)((0, _actions.setNbContacts)(nbContacts));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function* getInitialAcceptedContacts() {
  try {
    // Get first page of my accepted contacts
    var {
      data
    } = yield (0, _effects.call)(_apis.$getAcceptedContacts, _constants.NUMBER_OF_CONTACTS_EACH_CALL, 1);

    // Set contacts into entities.contact
    yield* (0, _api.normalizeApiResponse)(data, [_schemas.contacts]);
    yield (0, _effects.put)((0, _actions.setAcceptedContactsLoaded)(true));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function* getNewPageOfContacts() {
  try {
    var page = (yield (0, _effects.select)(_selectors.getCurrentPage)) + 1;
    var {
      data
    } = yield (0, _effects.call)(_apis.$getAcceptedContacts, _constants.NUMBER_OF_CONTACTS_EACH_CALL, page);
    yield (0, _effects.put)((0, _actions.setCurrentPage)(page));
    yield* (0, _api.normalizeApiResponse)(data, [_schemas.contacts]);
  } catch (e) {
    var _e$response;
    if ((e === null || e === void 0 || (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) !== 416) yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function* getPendingContacts() {
  try {
    // Get all my pending contacts
    var response = yield (0, _effects.call)(_apis.$getPendingContacts);

    // Set contacts into entities.contact
    var _pendingContacts = yield* (0, _api.normalizeApiResponse)(response.data, [_schemas.contacts]);
    yield (0, _effects.put)((0, _actions.setPendingContacts)(_pendingContacts));
    yield (0, _effects.put)((0, _actions.setPendingContactsLoaded)(true));
  } catch (e) {
    yield (0, _effects.call)(_errorHandler.default.captureException, e);
  }
}
function searchContacts(_ref) {
  var {
    sip,
    page
  } = _ref;
  return function* () {
    var query = yield (0, _effects.select)(state => state.contacts.query);

    // should be at least 2 char , if not rejected by the backend
    if ((query === null || query === void 0 ? void 0 : query.length) < 2) {
      yield (0, _effects.put)((0, _actions.setSearchContactResult)(null));
    }
    try {
      var {
        data
      } = yield (0, _effects.call)(_apis.$searchContacts, query, page, sip);
      var _searchResults = yield* (0, _api.normalizeApiResponse)(data, [_schemas.contacts]);
      yield (0, _effects.put)((0, _actions.setSearchContactResult)(_searchResults));
    } catch (e) {
      if ((0, _middlewares.isNetworkError)(e)) return;
      if (e.response && e.response.status !== 416) {
        yield (0, _effects.put)((0, _actions2.addNotification)({
          message: _i18n.default.translate('default.error'),
          referenceError: 'RE5',
          error: e
        }));
      }
    }
  }();
}
function getSingleContact(_ref2) {
  var {
    _user
  } = _ref2;
  return function* () {
    try {
      var result = yield (0, _effects.call)(_apis.$getSingleContact, _user);
      yield* (0, _api.normalizeApiResponse)(result.data, _schemas.contacts);
    } catch (e) {
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function addNewContact(_ref3) {
  var {
    user
  } = _ref3;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$postContact, user.id);
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('notification.invitation.user.sended.success', {
          username: user.firstname
        }),
        model: user
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'RE1',
        error: e
      }));
      yield (0, _effects.call)(_errorHandler.default.captureException, e);
    }
  }();
}
function acceptContact(_ref4) {
  var {
    _user
  } = _ref4;
  return function* () {
    yield (0, _effects.put)((0, _actions.updateContactStatus)(_user, _constants.CONTACT_STATUS.ACCEPTED));
  }();
}
function rejectContact(_ref5) {
  var {
    _user
  } = _ref5;
  return function* () {
    yield (0, _effects.put)((0, _actions.updateContactStatus)(_user, _constants.CONTACT_STATUS.DECLINED));
  }();
}
function updateContactStatus(_ref6) {
  var {
    _user,
    status
  } = _ref6;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$patchContact, _user, status);
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('sagas.contact.updated')
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'RE2',
        error: e
      }));
    }
  }();
}
function deleteContact(_ref7) {
  var {
    _user
  } = _ref7;
  return function* () {
    try {
      yield (0, _effects.call)(_apis.$deleteContact, _user);
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('sagas.contact.deleted')
      }));
    } catch (e) {
      yield (0, _effects.put)((0, _actions2.addNotification)({
        message: _i18n.default.translate('default.error'),
        referenceError: 'RE3',
        error: e
      }));
    }
  }();
}
function wsPostContact(_ref8) {
  var {
    payload
  } = _ref8;
  return function* () {
    if (payload) {
      var _newPendingContact = yield* (0, _api.normalizeApiResponse)(payload, _schemas.contacts);
      if (payload.isInitiator === false && _newPendingContact) {
        yield (0, _effects.put)((0, _actions.addPendingContact)(_newPendingContact));
      }
    }
  }();
}
function wsPutContact(_ref9) {
  var {
    payload
  } = _ref9;
  return function* () {
    var _newContact = yield* (0, _api.normalizeApiResponse)(payload, _schemas.contacts);
    yield (0, _effects.put)((0, _actions.removePendingContact)(_newContact));
    yield (0, _effects.put)((0, _actions.addNbContacts)(1));
  }();
}
function wsDeleteContact(_ref10) {
  var {
    payload
  } = _ref10;
  return function* () {
    var correctPayload = _objectSpread(_objectSpread({}, payload), {}, {
      contactStatus: _constants.CONTACT_STATUS.DECLINED
    }); // I have to put the correct contactStatus or else my contact.entities won't be correct anymore.
    var _removedContact = yield* (0, _api.normalizeApiResponse)(correctPayload, _schemas.contacts);
    var pendingContacts = yield (0, _effects.select)(_selectors._pendingContactsSelector);
    if (pendingContacts.includes(_removedContact)) {
      yield (0, _effects.put)((0, _actions.removePendingContact)(_removedContact));
    } else {
      yield (0, _effects.put)((0, _actions.addNbContacts)(-1));
    }
  }();
}
function* root() {
  yield (0, _effects.all)([(0, _sagas.takeLatest)([_types3.WS_CONNECT, _types2.REQUEST_LOGIN_SUCCESS], getNbContacts), (0, _sagas.takeLatest)([_types3.WS_CONNECT, _types2.REQUEST_LOGIN_SUCCESS], getInitialAcceptedContacts), (0, _sagas.takeLatest)([_types3.WS_CONNECT, _types2.REQUEST_LOGIN_SUCCESS], getPendingContacts), (0, _sagas.takeLatest)(types.GET_NEW_PAGE_OF_CONTACTS, getNewPageOfContacts), (0, _sagas.takeLatest)(types.GET_SINGLE_CONTACT, getSingleContact), (0, _sagas.takeLatest)(types.ADD_NEW_CONTACT, addNewContact), (0, _sagas.takeLatest)(types.ACCEPT_CONTACT, acceptContact), (0, _sagas.takeLatest)(types.REJECT_CONTACT, rejectContact), (0, _sagas.takeLatest)(types.UPDATE_CONTACT_STATUS, updateContactStatus), (0, _sagas.takeLatest)(types.DELETE_CONTACT, deleteContact), (0, _sagas.debounce)(200, types.REQUEST_GET_SEARCH_CONTACTS, searchContacts), (0, _sagas.takeEvery)(types.WS_POST_CONTACT, wsPostContact), (0, _sagas.takeEvery)(types.WS_PUT_CONTACT, wsPutContact), (0, _sagas.takeEvery)(types.WS_DELETE_CONTACT, wsDeleteContact)]);
}
module.exports = exports.default;